import * as Yup from 'yup';

import type { CaseProgramFormInterface, CreateCaseRetainerInterface } from 'types';
import { validateField, ValidationType } from './formValidation';

export const caseProgramDefaultValues: CaseProgramFormInterface = {
    country: '',
    programName: '',
};

export const caseProgramValidationSchema = Yup.object({
    country: validateField(ValidationType.STRING),
    programName: validateField(ValidationType.STRING),
});

export const createCaseRetainerDefaultValues: CreateCaseRetainerInterface = {
    agreementType: '',
    templateId: '',
    agentId: '',
    signingBlocked: false,
};

export const getCreateCaseRetainerValidationSchema = ({
    requireType,
    requireAgent,
}: {
    requireType: boolean;
    requireAgent: boolean;
}) =>
    Yup.object({
        agreementType: requireType ? validateField(ValidationType.STRING) : Yup.string().nullable(),
        templateId: validateField(ValidationType.STRING),
        agentId: requireAgent ? validateField(ValidationType.STRING) : Yup.string().nullable(),
        signingBlocked: Yup.boolean().required(),
    });
